import { apiSlice } from "../../apiSlice";

export const blogApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBlogList: build.query({
      query: ({ page, limit = 6 }) =>
        `/public/blog-page/paginate-list?limit=${limit}&page=${page}`,
    }),
    getFeaturedBlog: build.query({
      query: () => `/public/blog-page/featured-post?limit=5`,
    }),
    getTrandingBlog: build.query({
      query: () => `/public/blog-page/trending-topics?limit=5`,
    }),
  }),
});
export const {
  useGetFeaturedBlogQuery,
  useGetBlogListQuery,
  useGetTrandingBlogQuery,
} = blogApi;
